import { sanitize } from 'isomorphic-dompurify'

export const sanitizeReasonHtml = (html: string) =>
  sanitize(html, {
    ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 's', 'a', 'sub', 'sup'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
  })
